import SectionHeading from "./SectionHeading";
import { latestMovies } from "@/mocks/home";
import type { MovieDetail } from "../types";

interface LatestListProps {
  onOpen: (movie: MovieDetail) => void;
  onNotify: (message: string) => void;
}

export default function LatestList({ onOpen, onNotify }: LatestListProps) {
  return (
    <section id="latest" className="w-full border-y border-background-300/40 bg-background-100/40">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          index="02"
          eyebrow="最新电影"
          title="最新电影 · 片单"
          desc="标题加一句话摘要，看对眼再点进去。每条片目右侧留了醒目的观看入口，也能直接收藏进深夜片单。"
        />

        <ul className="mt-6 grid grid-cols-1 gap-x-8 lg:grid-cols-2">
          {latestMovies.map((movie, i) => (
            <li
              key={movie.id}
              className="flex flex-col gap-3 border-b border-background-300/35 py-5 md:flex-row md:items-center md:gap-5"
            >
              <span className="font-label w-10 shrink-0 text-xl leading-none text-background-500">
                {String(i + 1).padStart(2, "0")}
              </span>

              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <button
                    type="button"
                    onClick={() => onOpen(movie)}
                    className="cursor-pointer text-left font-display text-base font-bold text-foreground-950 transition-colors hover:text-primary-300"
                  >
                    {movie.title}
                  </button>
                  <span className="text-[11px] text-foreground-400">{movie.en}</span>
                </div>
                <p className="mt-1 text-xs text-foreground-500">
                  {movie.year} · {movie.genre} · {movie.duration} · {movie.region}
                  <span className="ml-2 text-primary-300">★ {movie.score}</span>
                </p>
                <p className="mt-2 text-sm leading-relaxed text-foreground-500">{movie.summary}</p>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {movie.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full border border-secondary-300/30 bg-secondary-100/10 px-2.5 py-0.5 text-[11px] text-secondary-200"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>

              <div className="flex shrink-0 items-center gap-2 md:flex-col md:items-stretch">
                <button
                  type="button"
                  onClick={() => onOpen(movie)}
                  className="flex flex-1 cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-play-fill" />
                  观看
                </button>
                <button
                  type="button"
                  onClick={() => onNotify(`已把《${movie.title}》加入下载队列`)}
                  className="flex flex-1 cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300/60 px-4 py-2 text-sm text-foreground-600 transition-colors hover:border-accent-400 hover:text-accent-300"
                >
                  <i className="ri-download-2-line" />
                  下载
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}